import type {AjaxActionType, CategoryType} from 'constants/flow/flowTypes';
import {CATEGORY} from 'constants/actions';

export const initialState = {
    items: [],
    total_items_count: 0,
    status: 'pending',
    id: 0,
    title: '',
    description: '',
    has_sunglasses: false,
    tabbed_banner_id: 0,
    show_only_rx: 0,
    is_contact_lenses: false,
    gender: 0,
    grid_banner: {
        position: 0,
        content: '',
    },
    meta: {
        description: '',
    },
};

/**
 * Get current category data
 *
 * @param {object} state Current state
 * @param {AjaxActionType} action Received action
 * @returns {CategoryType} Current category data
 */
export default function category(state: {} = initialState, action: AjaxActionType): CategoryType {
    switch (action.type) {
        case `${CATEGORY.GET_CATEGORY}_FULFILLED`:
            return {
                ...state,
                ...action.payload.data,
                status: 'fulfilled',
            };
        case `${CATEGORY.GET_CATEGORY}_PENDING`:
            return {
                ...state,
                status: 'pending',
            };
        case `${CATEGORY.GET_CATEGORY}_REJECTED`:
            return {
                ...state,
                ...action.payload.response.data,
                status: 'rejected',
            };
        case CATEGORY.CLEAR_CATEGORY_DATA: {
            return initialState;
        }
        default:
            return state;
    }
}
